<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{title}}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <div>
          <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref='table' id="dataTable">
            <template slot="afterFilter">
              <tr class="VueTables__no-results">
                <b-button @click="resetFilters">Limpiar filtro</b-button>
              </tr>

              <tr v-if="loading" class="VueTables__no-results">
                <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
              </tr>

            </template>

            <div class="text-center" slot="actions" slot-scope="props">
            <a target="_blank" href="#" @click.prevent="openReport(props.row.id)"
               class="fa fa-lg fa-search text-primary"></a>&nbsp;
          </div>

<!--            <div slot="beforeLimit">-->
<!--              <download-excel-->
<!--                class="btn"-->
<!--                :fetch="fetchData"-->
<!--                :fields="json_fields2"-->
<!--                worksheet="Stock"-->
<!--                :name="name"-->
<!--                :before-generate="startDownload"-->
<!--                :before-finish="finishDownload">-->
<!--                <b-link>Descargar</b-link>-->
<!--              </download-excel>-->

<!--            </div>-->


          </v-server-table>
        </div>
      </b-card>
      <b-modal
          id="modal-report"
          ref="reportModal"
          centered size="lg"
          title="Detalle de documento"
          @ok="report=null; data=null"
          ok-only
        >
          <div class="text-center">
            <b-spinner v-if="loading" label="Spinning"></b-spinner>
          </div>
          <component  :is="report" :report_data="report_data"></component>
        </b-modal>
    </div>
  </div>
</template>


<script>
  import Vue from 'vue'
  import {ServerTable, Event} from 'vue-tables-2'
  import JsonExcel from 'vue-json-excel'
  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'
  import Report from './Report'

  numeral.locale('es');
  window.axios = require('axios');


  var d = new Date();

  Vue.use(ServerTable);
  Vue.component('downloadExcel', JsonExcel);

  export default {
    name: 'DocumentList',
    components: {
      ServerTable,
      Report,
    },
    mounted() {
      Event.$on('vue-tables.loading', () => {
        this.loading = true;
      });

      Event.$on('vue-tables.loaded', () => {
        this.loading = false;
      });
    },
    data() {
      return {
        title: "Listado de documentos",
        loading: false,
        report: 'report',

        json_meta: [
          [
            {
              'key': 'charset',
              'value': 'utf-8'
            }
          ]
        ],
        json_fields2: {
          'Exportadora': 'client_customer_name',
        },
        columns: [
          "date",
          "number",
          // "note",
          "company_number",
          "company",
          "document_type",
          "total_kilograms",
          "total_quantity",
          "total_pallets",
          "actions",
        ],
        report_data: null,
        theme: 'bootstrap4',
        template: 'default',
        options: {
          responseAdapter: function (resp) {
            const results = resp.data.results;
            const items = [];
            for (let key in results) {
              const item = results[key];
              items.push(item)
            }
            return {
              data: items,
              count: resp.data.count
            };
          },
          texts: {
            filter: "Filtrar:",
            filterBy: 'Filtrar por {column}',
            count: ' ',
            filterPlaceholder: "Buscar...",
            columns: 'Columnas',
            limit: "Registros:",
          },
          perPage: 10,
          filterByColumn: true,
          filterable: [
            "date",
            "number",
            "note",
            "company",
            "company_number",
            "document_type",
          ],
          headings: {
            date: 'Fecha',
            number: 'Numero',
            company: 'Proveedor',
            company_number: 'Rut',
            document_type: 'Tipo Documento',
            total_kilograms: 'KN',
            total_quantity: 'Bandejas/bins',
            total_pallets: 'Pallets',
            actions: '',
          },
          debounce: 800,
          columnsDropdown: true,
          columnsDisplay: {
            document: 'not_desktop',
            product_name: 'not_desktop',
            product_type_name: 'min_desktop',
            string_specs: 'min_desktop',
            daystay: 'not_desktop',
            condition: 'min_desktop',
            lot_number: 'min_desktop',
            in_process: 'not_desktop',
            last_inspection: 'not_desktop',
          },
          columnsClasses: {
            total_kilograms: 'text-right',
            total_quantity: 'text-right',
            total_pallets: 'text-right',
          },
          listColumns: {
            document_type: [
              {id: 0, text: 'Guia de despacho'},
              {id: 1, text: 'Factura'},
              {id: 2, text: 'Otro'},
            ]
          },
          sortable: [],
          sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },

      }
    },
    filters: {
      moment(value) {
        return moment(value).format('DD-MM-YYYY')
      }
    },
    computed: {
      name() {
        return "Stock " + moment(Date.now()).format('YYYYMMDD h:mm') + ".xls"
      },
      url() {
        return '/bagno/document/?'
      }
    },
    methods: {
      async openReport(document_id) {

        const thisV = this;
        thisV.loading = true;
        thisV.$bvModal.show("modal-report");
        try {
          const response = await thisV.$axios({
            method: "GET",
            url: "bagno/document/"+document_id+"/document_report/",
          });
          thisV.report_data = response.data;
          thisV.report='report';
          thisV.loading = false;
        } catch (error) {
          console.log(error);
          thisV.loading = false;
        }
      },
      jsonToQueryString(json) {
        var result = {};
        for (var key in json) {
          if (json[key] !== '') {
            result[key] = json[key];
          }
        }

        var a = encodeURIComponent(JSON.stringify(result));

        return '/api/v1/stock/?query=' + a;
      },
      resetFilters() {
        for (var key in this.$refs['table'].query) {
          this.$refs['table'].query[key] = '';
        }
        this.$refs['table'].refresh();
      },

      async fetchData() {
        const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
        return response.data.results;
      },
      startDownload() {
        this.loading = true
      },
      finishDownload() {
        this.loading = false
      },
    },
  };
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }

    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
      padding: 0.25rem;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__columns-dropdown {
      padding-right: 20px;
    }

    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }

    .VueTables__number-field {
      border: 4px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
